import React, { FunctionComponent, PropsWithChildren } from 'react';

import { TooltipStateful } from '@yandex-360/orb-components/dist/components/Tooltip';

interface ToolbarOrbTooltipPropsBase {
    content: React.ReactNode;
    isDisabled?: boolean;
}

export type ToolbarOrbTooltipProps = PropsWithChildren<ToolbarOrbTooltipPropsBase>;

export const ToolbarOrbTooltip: FunctionComponent<ToolbarOrbTooltipProps> = ({ children, ...props }) => {
    return (
        <TooltipStateful placement="top" offset={18} delay={0} trigger="hover" {...props}>
            <div>{children}</div>
        </TooltipStateful>
    );
};
